module.exports = __webpack_public_path__ + "img/user.1897f975.png";